export const browserarticlesData = [
    {
        "title":"Quick Questions are answered",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"Lorem Ipsum is simply dummy text of the printing"
            },
            {
                "icon":"file-text",
                "paragraph":"Lorem Ipsum has been the industry's standard dummy"
            },
            {
                "icon":"file-text",
                "paragraph":"When an unknown printer took a galley"
            },
            {
                "icon":"file-text",
                "paragraph":"But also the leap into electronic typesetting,"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (40)"
            }
        ]

    },
    {
        "title":"Integrating WordPress with Your Website",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"It was popularised in the 1960s with the release"
            },
            {
                "icon":"file-text",
                "paragraph":"Etraset sheets containing Lorem Ipsum passages"
            },
            {
                "icon":"file-text",
                "paragraph":"Desktop publishing software like Aldus PageMaker "
            },
            {
                "icon":"file-text",
                "paragraph":"Making this the first true generator on the Internet."
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (90)"
            }
        ]
    },
    {
        "title":"WordPress Site Maintenance",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"The point of using Lorem Ipsum is that it has a more-or-less"
            },
            {
                "icon":"file-text",
                "paragraph":"Normal distribution of letters, as opposed to using"
            },
            {
                "icon":"file-text",
                "paragraph":"Lorem Ipsum, you need to be sure there isn't anything"
            },
            {
                "icon":"file-text",
                "paragraph":"Repetition, injected humour, or non words etc"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (50)"
            }
        ]
    },
    {
        "title":"Meta Tags in WordPress",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"Nemo enim ipsam voluptatem quia voluptas sit"
            },
            {
                "icon":"file-text",
                "paragraph":"Ipsum quia dolor sit amet, consectetur"
            },
            {
                "icon":"file-text",
                "paragraph":"Sed quia non numquam eius modi tempora incidunt"
            },
            {
                "icon":"file-text",
                "paragraph":"Lorem eum fugiat quo voluptas nulla pariatu"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (90)"
            }
        ]
    },
    {
        "title":"WordPress in Your Language",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"Desktop publishing software like Aldus PageMaker"
            },
            {
                "icon":"file-text",
                "paragraph":"Etraset sheets containing Lorem Ipsum passages"
            },
            {
                "icon":"file-text",
                "paragraph":"It was popularised in the 1960s with the release"
            },
            {
                "icon":"file-text",
                "paragraph":"Making this the first true generator on the Internet"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (50)"
            }
        ]
    },
    {
        "title":"Know Your Sources",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"The point of using Lorem Ipsum "
            },
            {
                "icon":"file-text",
                "paragraph":"It has a more-or-less normal distribution of letters"
            },
            {
                "icon":"file-text",
                "paragraph":"Et harum quidem rerum facilis est et expedita"
            },
            {
                "icon":"file-text",
                "paragraph":"Nam libero tempore, cum soluta nobis est eligendi"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (26)"
            }
        ]
    },
    {
        "title":"Validating a Website",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"When our power of choice is untrammelled "
            },
            {
                "icon":"file-text",
                "paragraph":"It will frequently occur that pleasures"
            },
            {
                "icon":"file-text",
                "paragraph":"who fail in their duty through weakness"
            },
            {
                "icon":"file-text",
                "paragraph":"At vero eos et accusamus et iusto"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (10)"
            }
        ]
    },
    {
        "title":"Quick Questions are answered",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"Quis autem vel eum iure reprehenderit"
            },
            {
                "icon":"file-text",
                "paragraph":"Ducimus blanditiis praesentium voluptatum"
            },
            {
                "icon":"file-text",
                "paragraph":"Omnis voluptas assumenda est"
            },
            {
                "icon":"file-text",
                "paragraph":"Produces no resultant pleasure"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (21)"
            }
        ]
    },
    {
        "title":"Integrating WordPress with Your Website",
        "subdata":[
            {
                "icon":"file-text",
                "paragraph":"Lorem Ipsum passage, and going through"
            },
            {
                "icon":"file-text",
                "paragraph":"The first line of Lorem Ipsum, Lorem ipsum "
            },
            {
                "icon":"file-text",
                "paragraph":"Thus comes from a line in section"
            },
            {
                "icon":"file-text",
                "paragraph":"First true generator on the Internet"
            },
            {
                "icon":"arrow-right",
                "paragraph":"See More (34)"
            }
        ]
    }
]

export const knowledgeDetail = [
    {
        title:"UX Development",
        date:18,
        month:"Dec"
    },
    {
        title:"Business Analyst",
        date:28,
        month:"Dec"
    },
    {
        title:"Web Development",
        date:5,
        month:"Jan"
    }
]

export const knowledgeCategorie = [
    {
        title : "Design",
        subdata:[
            {
                header:"UI Design",
                badge:"28"
            },
            {
                header:"UX Design",
                badge:"35"
            },
            {
                header:"Interface Design",
                badge:"17"
            },
            {
                header:"User Experience",
                badge:"26"
            }
        ]
    },
    {
        title : "Development",
        class:"pt-0",
        subdata:[
            {
                header:"Frontend Development",
                badge:"48"
            },
            {
                header:"Backend Development",
                badge:"19"
            }
        ]
    }
]